var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup237597(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "white",
    stroke: "#EBA10F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3036 33.1429V33.6429H31.8036H44.5357C45.6201 33.6429 46.5 34.5228 46.5 35.6072V43.8215C46.5 44.9058 45.6201 45.7858 44.5357 45.7858H26.4643C25.3799 45.7858 24.5 44.9058 24.5 43.8215V35.6072C24.5 34.5228 25.3799 33.6429 26.4643 33.6429H27.6964H28.1964V33.1429V27.8806C28.1964 23.8374 31.4452 20.5144 35.4761 20.5C39.5116 20.4856 42.8036 23.7678 42.8036 27.8036V28.6251C42.8036 29.0317 42.4781 29.3572 42.0714 29.3572H40.4286C40.0219 29.3572 39.6964 29.0317 39.6964 28.6251V27.8036C39.6964 25.4778 37.7914 23.5839 35.4591 23.6072L35.459 23.6072C33.144 23.6306 31.3036 25.5505 31.3036 27.8498V33.1429ZM35.5 43.5001C36.9107 43.5001 38.0536 42.3572 38.0536 40.9465V38.4822C38.0536 37.0715 36.9107 35.9286 35.5 35.9286C34.0893 35.9286 32.9464 37.0715 32.9464 38.4822V40.9465C32.9464 42.3572 34.0893 43.5001 35.5 43.5001Z",
    fill: "#EBA10F",
    stroke: "#EBA10F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup237597);
export default __webpack_public_path__ + "static/media/Group 237597.6770ebbf5f5122ef84b26f33e1987fe9.svg";
export { ForwardRef as ReactComponent };